import { FormControl, Stack, Typography, TextField, Button } from '@mui/material';
import { useState } from 'react';
import { Message } from '../../../components/Message';
import { saveNewPassword } from '../../../helpers/userMessage';

import './style.css';
import { useForm } from '../../../hooks/useForm';

export const PasswordForm = () => {

    const [loginIsCorrect, setLoginIsCorrect] = useState(true);
    const [isSend, setIsSend] = useState(false);
    const [body, setBody] = useState({});

    const [formValues, handleInputChange, reset] = useForm({
        password: '',
        repeat: ''
    });

    const { password, repeat } = formValues;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password !== '' && password === repeat) {
            setBody({
                password: password
            })
            setIsSend(!isSend)

            
        } else {
            setLoginIsCorrect(false)
        }
    }


    return (
        <FormControl component='form' className="form_repeatPassword" onSubmit={handleSubmit} sx={{ mt: '4rem' }}>
            <Stack spacing={1} pt={2} pb={2} alignItems='center'>
                <Typography textAlign='center' variant="h5" color="primary">Crear nueva contraseña</Typography>

                <TextField
                    label="Nueva contraseña"
                    type="password"
                    variant="standard"
                    name="password"
                    value={password}
                    onChange={handleInputChange}
                    sx={{ width: '70%' }}
                />
                <TextField
                    label="Confirmar contraseña"
                    type="password"
                    variant="standard"
                    name="repeat"
                    value={repeat}
                    onChange={handleInputChange}
                    sx={{ width: '70%', paddingBottom: '2rem' }}
                />
                <Button variant="contained" size='small' type='submit'>Guardar contraseña</Button>
            </Stack>
            {!loginIsCorrect && <Typography variant='subtitle1' textAlign='center' sx={{ color: 'red' }}>Las contraseñas deben ser iguales</Typography>}
            {isSend && <Message reset={reset} setIsCreate={setIsSend} messages={saveNewPassword} method='PUT' body={body} />}
        </FormControl>
    )
}
